import { Component, inject, OnInit } from '@angular/core';
import { DashboardService } from '../../../service/events/dashboard.service';

@Component({
    selector: 'app-fincas',
    standalone: false,
    templateUrl: './fincas.component.html',
    styleUrls: ['./fincas.component.scss']
})
export class FincasComponent implements OnInit {

    dashboardEvents = inject(DashboardService);

    ngOnInit(): void {
        this.dashboardEvents.setMenuItem('fincas');
    }
}
